export enum StageInfo {
  CAPDEV = 'Capdev',
  TEST = 'Test',
  PROD = 'Prod',
  INT = 'Int',
  DEV = 'Dev',
}